module.exports = "/src/views/player/help/images/azs2.jpg";